"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["src", "aspectRatio", "priority", "width", "height", "quality"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from 'react';
import { useAgImageServerUrl } from '@autoguru/image-server-config';
import { Box } from '@autoguru/overdrive';
import Head from 'next/head';
import { useNextImages } from '../NextImageProvider/NextImageProvider';
import Picture from './Picture';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const NextPicture = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _placeholderImages$in, _placeholderImages$in2;
  let {
      src: incomingSrc,
      aspectRatio,
      priority,
      width,
      height,
      quality = 60
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    srcset,
    src
  } = useAgImageServerUrl({
    url: incomingSrc,
    quality
  });
  const {
    placeholderImages
  } = useNextImages(true);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [priority || (_placeholderImages$in = placeholderImages[incomingSrc]) !== null && _placeholderImages$in !== void 0 && _placeholderImages$in.priority ? /*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("link", {
        rel: "preload",
        as: "image",
        imageSrcSet: srcset,
        imageSizes: "100vw"
      })
    }) : null, /*#__PURE__*/_jsx(Box, {
      position: "relative",
      width: "full",
      style: {
        paddingBottom: `${100 * (1 / aspectRatio)}%`,
        width: width,
        height: height
      },
      children: src || srcset ? /*#__PURE__*/_jsx(Box, {
        position: "absolute",
        width: "full",
        height: "full",
        children: /*#__PURE__*/_jsx(Picture, _objectSpread({
          ref: ref,
          lazy: !(priority || (_placeholderImages$in2 = placeholderImages[incomingSrc]) !== null && _placeholderImages$in2 !== void 0 && _placeholderImages$in2.priority),
          src: src,
          srcset: srcset,
          aspectRatio: aspectRatio,
          width: width,
          height: height
        }, props))
      }) : null
    })]
  });
});
export default NextPicture;